export default "__VITE_ASSET__CUK2ToFM__"